import React, { useEffect } from "react";
import styles from "./ParticlesBackground.module.css";

const ParticlesBackground = ({ id = "particles-js", className = "" }) => {
  useEffect(() => {
    let isUnmounted = false;

    const initParticles = async () => {
      try {
        await import("particles.js");
        if (
          typeof window !== "undefined" &&
          window.particlesJS &&
          !isUnmounted
        ) {
          window.particlesJS(id, {
            particles: {
              number: {
                value: 7,
                density: { enable: true, value_area: 950 },
              },
              color: { value: "#ffffff" },
              shape: {
                type: "circle",
                stroke: { width: 0, color: "#000000" },
                polygon: { nb_sides: 5 },
              },
              opacity: {
                value: 0.5,
                random: false,
                anim: {
                  enable: false,
                  speed: 1,
                  opacity_min: 0.1,
                  sync: false,
                },
              },
              size: {
                value: 3,
                random: true,
                anim: { enable: false, speed: 30, size_min: 0.1, sync: false },
              },
              line_linked: {
                enable: true,
                distance: 500,
                color: "#ffffff",
                opacity: 0.8,
                width: 1.5,
              },
              move: {
                enable: true,
                speed: 2,
                direction: "none",
                random: false,
                straight: false,
                out_mode: "out",
                bounce: false,
                attract: { enable: false, rotateX: 800, rotateY: 200 },
              },
            },
            interactivity: {
              detect_on: "window",
              events: {
                onhover: { enable: true, mode: "grab" },
                onclick: { enable: true, mode: "" },
                resize: true,
              },
              modes: {
                grab: {
                  distance: 400,
                  line_linked: {
                    opacity: 1,
                  },
                },
                bubble: {
                  distance: 400,
                  size: 40,
                  duration: 2,
                  opacity: 0.8,
                  speed: 3,
                },
                repulse: { distance: 100, duration: 0.4 },
                push: { particles_nb: 4 },
                remove: { particles_nb: 2 },
              },
            },
            retina_detect: true,
          });
        }
      } catch (err) {
        // Silently ignore if particles.js fails to load
        console.warn("Failed to load particles.js:", err);
      }
    };

    initParticles();

    return () => {
      isUnmounted = true;
      if (
        typeof window !== "undefined" &&
        window.pJSDom &&
        window.pJSDom.length
      ) {
        try {
          window.pJSDom.forEach((inst) => {
            if (
              inst &&
              inst.pJS &&
              inst.pJS.fn &&
              inst.pJS.fn.vendors &&
              inst.pJS.fn.vendors.destroypJS
            ) {
              inst.pJS.fn.vendors.destroypJS();
            }
          });
          window.pJSDom = [];
        } catch (err) {
          // Silently ignore cleanup errors
          console.warn("Error during particles cleanup:", err);
        }
      }
    };
  }, [id]);

  return <div id={id} className={`${styles.particles} ${className}`} />;
};

export default ParticlesBackground;
